export default __webpack_public_path__ + "7b06d7efd0dbd5e85f52be210d4c69e0.jpg";